<template>
<div class="chapter">
<div class="inner_page">
<p class="title1">COACH</p>
<p class="title1a"><span class="bolditalic">RUN</span></p>
<p class="title1b"><span class="bold">WIN</span></p>
<p class="title2">A COMPREHENSIVE GUIDE TO</p>
<p class="title3"><em class="italic">Coaching High School Cross Country, Running Fast, and Winning Championships</em></p>
<p class="title4">KEN SAYLES</p>
<p class="title5"><em class="italic">2014 Southern California “Coach of the Year”</em></p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7bb66c38